/* eslint-disable */
export const styleId = 'layout-components-modals-style';
export const userAuthorizationStateStyleId = 'user-authorization-state-style';

// shouldn't have closures, inlined to html via .toString()
export function initCookieModalHack() {
    try {
        if (typeof window !== 'undefined') {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            run();
        }
    } catch (err) {
        console.error(err);
    }

    function run() {
        // 1. constants
        const cookieName = 'cookies_accepted';
        const cookiesRejectedLSKey = 'cookies_rejected';
        const styleId = 'layout-components-modals-style';
        const userAuthorizationStateStyleId = 'user-authorization-state-style';

        // 2. variables
        const style = document.querySelector(`#${styleId}`);
        const userAuthorizationStateStyle = document.querySelector(`#${userAuthorizationStateStyleId}`);
        // @ts-ignore
        const user = window.__INITIAL_STATE__?.userStore?.user;
        let styleTextNode: Text;
        let userAuthorizationStateStyleTextNode: Text;

        // 3. global variables
        // sync with projects/root/src/common-modules/layout-components/constants/domains.ts
        // @ts-ignore
        window.__shouldUseChatStub = [ 'rb.m2', 'm2.region.vtb.ru' ].includes(document.location.hostname);
        // @ts-ignore
        window.__isCookieModalVisible =
            !(document.cookie ? document.cookie.split('; ') : []).find(
                (cookie) => decodeURIComponent(cookie.split('=')[0]) === cookieName,
            ) && !window?.localStorage?.getItem(cookiesRejectedLSKey);
        // @ts-ignore
        window.__isUserAuthorized = Boolean(user && user.isAuthenticated);

        // 4. callbacks
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        // @ts-ignore
        window.__hideCookiesModal = hideCookiesModal;

        // 5. main logic
        // @ts-ignore
        if (window.__isCookieModalVisible) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            updateCss();
        } else {
            // includes updateCss() inside
            // @ts-ignore
            window.__hideCookiesModal();
        }

        updateUserInfoCss();

        // 6. functions
        function updateCss() {
            let css = '';

            // @ts-ignore
            if (window.__isCookieModalVisible) {
                // node_modules/@vtblife/uikit/dist/css/mixins/ds-breakpoint.css
                css += `
                .chatWidget, .chatWidgetButton, .chatListButton {
                    bottom: 152px !important;
                }

                @media screen and (max-width: 767px) {
                    .chatWidget, .chatWidgetButton, .chatListButton {
                        bottom: 120px !important;
                    }
                }\n`;
            } else {
                css += `
                .cookie-consent-wrapper {
                    display: none !important;
                }\n`;
            }

            // @ts-ignore
            if (! window.__shouldUseChatStub) {
                css += `
                .chatWidgetButton {
                    display: none !important;
                }\n`;
            }

            if (! styleTextNode) {
                styleTextNode = document.createTextNode(css);
                style?.appendChild(styleTextNode);
            } else {
                styleTextNode.textContent = css;
            }
        }

        function hideCookiesModal() {
            // @ts-ignore
            window.__isCookieModalVisible = false;
            updateCss();
        }

        function updateUserInfoCss() {
            let css = '';

            // @ts-ignore
            if (window.__isUserAuthorized) {
                css += `
                .initialAuthorizedUser {
                    display: block !important;
                }\n`;
            } else {
                css += `
                .initialUnauthorizedUser {
                    display: block !important;
                }\n`;
            }

            if (! userAuthorizationStateStyleTextNode) {
                userAuthorizationStateStyleTextNode = document.createTextNode(css);
                userAuthorizationStateStyle?.appendChild(userAuthorizationStateStyleTextNode);
            } else {
                userAuthorizationStateStyleTextNode.textContent = css;
            }
        }
    }
}
